/* global $, showErrMsg, showAlertMsg, getChargeCcIdempotencyKey, rotateChargeCcIdempotencyKey, beginChargeCcAttempt, endChargeCcAttempt, nextChargeCcGeneration, isCurrentChargeCcGeneration, chargeWentThrough, releaseAttemptAfterConfirmedCharge, lockAfterUnknownResult */

function applyChargeCcPageResult(response) {
    const {
        msg = '',
        success_msg = '',
        error = '',
        email_sent = true,
        page_info = '',
    } = response || {};

    if (msg) {
        showErrMsg(msg);
    } else if (success_msg) {
        showAlertMsg(success_msg);
    } else if (error) {
        showErrMsg(error);
    } else if (!email_sent) {
        showAlertMsg('Thank you for your payment! We were unable to send a receipt; please contact the admin for your receipt.');
    }
    if (page_info) {
        $('#index_paging').empty().html(page_info).fadeIn('slow');
    }
}

function isSwipeCancelled(err) {
    if (err === 'cancelled') {
        return true;
    }
    return !!(err && err.message === 'cancelled');
}

window.initKioskSwipeCharge = function (config) {
    if (!config || !config.gatewayJavascriptUrl || !config.tokenizationSourceKey || !config.chargeUrl || !config.csrfToken) {
        showErrMsg('Card swipe is not configured. Please contact staff.');
        return;
    }

    const swipeButton = document.getElementById('swipeButton');
    if (!swipeButton) {
        return;
    }
    if (swipeButton.dataset.swipeChargeBound === '1') {
        return;
    }
    swipeButton.dataset.swipeChargeBound = '1';

    const instanceGeneration = nextChargeCcGeneration();
    let swipe = null;

    function setSwipeLocked(locked) {
        swipeButton.disabled = locked;
        swipeButton.setAttribute('aria-disabled', locked ? 'true' : 'false');
        swipeButton.classList.toggle('disabled', locked);
    }

    function resetSwipeAttempt() {
        rotateChargeCcIdempotencyKey();
        endChargeCcAttempt();
        setSwipeLocked(false);
    }

    function resetGatewayTokenization() {
        const existingGatewayScript = document.getElementById('GatewayJavascriptURL');
        if (existingGatewayScript) {
            existingGatewayScript.remove();
        }
        delete window.HostedTokenization;
        swipe = null;
    }

    resetGatewayTokenization();
    const script = document.createElement('script');
    script.id = 'GatewayJavascriptURL';
    script.src = config.gatewayJavascriptUrl;
    script.async = false;
    script.addEventListener('load', function () {
        if (!isCurrentChargeCcGeneration(instanceGeneration)) {
            return;
        }
        if (typeof window.HostedTokenization !== 'function') {
            showErrMsg('Unable to load the card reader. Please try again or contact staff.');
            return;
        }
        const hostedTokenization = new window.HostedTokenization(config.tokenizationSourceKey);
        hostedTokenization.name = 'token_window';
        swipe = hostedTokenization.create('swipe');
    });
    script.addEventListener('error', function () {
        if (!isCurrentChargeCcGeneration(instanceGeneration)) {
            return;
        }
        showErrMsg('Unable to load the card reader. Please try again or contact staff.');
    });
    document.head.appendChild(script);

    swipeButton.addEventListener('click', async function (event) {
        event.preventDefault();
        if (!isCurrentChargeCcGeneration(instanceGeneration)) {
            return;
        }
        if (!beginChargeCcAttempt()) {
            return;
        }
        if (!swipe) {
            endChargeCcAttempt();
            showErrMsg('Card swipe is not ready. Please wait a moment and try again.');
            return;
        }

        setSwipeLocked(true);
        try {
            const result = await swipe.getSwipe();
            if (!isCurrentChargeCcGeneration(instanceGeneration)) {
                endChargeCcAttempt();
                return;
            }
            $('#overlay').fadeIn();
            const swipePayload = {
                maskedCard: result.maskedCard,
                cardType: result.cardType,
                last4: result.last4,
                expiryMonth: result.expiryMonth,
                expiryYear: result.expiryYear,
                name: result.name,
                donation_type: config.donationType,
                donation_amount: config.donationAmount,
                campaign_id: config.campaignId,
                frequency_id: config.frequencyId,
                cover_surcharge: config.coverSurcharge,
                duration: config.duration,
                pledge_start_date: config.pledgeStartDate,
                run_today: config.runToday,
                use_open_payment_balance: $('#use_open_payment_balance').prop('checked') || false,
                open_payment_apply_amount: $('#open_payment_apply_amount').val() || '',
                process_type: 'nonce',
                is_swipe: true,
                type: 'swipe',
                save_card: $('#save_card').prop('checked'),
                idempotency_key: getChargeCcIdempotencyKey(),
                _token: config.csrfToken,
            };
            if (config.userId) {
                swipePayload.user_id = config.userId;
            }
            if (result.nonce) {
                swipePayload.nonce = result.nonce;
            }

            $.ajax({
                url: config.chargeUrl,
                type: 'POST',
                data: swipePayload,
                success: function (response) {
                    $('#overlay').fadeOut();
                    if (chargeWentThrough(response)) {
                        releaseAttemptAfterConfirmedCharge();
                        applyChargeCcPageResult(response);
                        return;
                    }
                    showErrMsg((response && response.error) || 'An error occurred');
                    resetSwipeAttempt();
                },
                error: function () {
                    $('#overlay').fadeOut();
                    lockAfterUnknownResult();
                    showErrMsg('A timeout error occurred. Do not swipe again. If you were not charged, ask staff for help.');
                },
            });
        } catch (err) {
            if (!isSwipeCancelled(err)) {
                $('#overlay').fadeOut();
                showErrMsg((err && err.message) || String(err));
            }
            resetSwipeAttempt();
        }
    });
};
